import { useTranslation } from "react-i18next"
import { CustomNoRowsOverlayWrapper } from "./stryle"

export function CustomNoRowsOverlay() {
	const { t } = useTranslation()
	return (
		<CustomNoRowsOverlayWrapper>
			<p>{t("UserManagement.No users found")}</p>
		</CustomNoRowsOverlayWrapper>
	)
}
